import { useDispatch, useSelector } from "react-redux";
import AddNewDropdown from "../dropdown/AddNewDropdown";
import styles from "./Header.module.css";
import LeftArrow from "../../assets/images/ArrowLeft.svg";
import {
  CLIENT_ADMIN_ROLE_ID,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  dateFormate,
  timeFormate,
} from "../../constants/constant";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonCta1 from "../button/ButtonCta1";
import { Box, CircularProgress } from "@mui/material";
import { setButtonAction } from "../../reduxSlices/headerSlice";
import CustomTooltip from "../tooltip/CustomTooltip";
import { ReactComponent as DownloadIcon } from "../../assets/images/Download.svg";
import { ReactComponent as ArrowRightGray } from "../../assets/images/ArrowRightGray.svg";
import moment from "moment";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const envLastUpdated = location?.state?.envLastUpdated;
  const tmzone = location?.state?.timezone;
  const searchParams = localStorage.getItem("searchParams");
  const transalationId = JSON.parse(localStorage.getItem("transalationId"));
  const headerData = useSelector((state) => state.header.header);
  const exportLoading = useSelector((state) => state?.package?.exportLoading);
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const pathName = window.location.pathname.replace(/\//g, "");
  const addButtonDisabled = useSelector(
    (state) => state.header.addButtonDisabled
  );
  const updateButtonDisabled = useSelector(
    (state) => state.header.updateButtonDisabled
  );
  const profileImage = useSelector(
    (state) => state?.user?.currentUser?.data?.profileImage
  );
  const isTranslationAdded = useSelector(
    (state) => state.translation.isTranslationAdded
  );

  const translationPage = [
    "appeal-categories",
    "custom-fields-categories",
    "appeal-custom-categories",
    "campaign-categories",
    "campaign-custom-categories",
    "appeal-id",
    "campaign-id",
    "dollar-threshold",
    "fund-categories",
    "fund-types",
    "fund-custom-fields",
  ];

  const isTranslationPage = translationPage?.includes(headerData.page);

  const handleGoBack = () => {
    if (
      headerData.page === "vfusers" ||
      headerData.page === "environments" ||
      headerData.page === "packages" ||
      headerData.page === "configure-translations"
    ) {
      navigate("/settings");
    } else if (
      headerData.page === "channel-translation" ||
      headerData.page === "program-translation" ||
      headerData.page === "annualgiving-translation" ||
      headerData.page === "appeal-category-translation" ||
      headerData.page === "fundpurpose-translation" ||
      headerData.page === "philanthropic-translation"
    ) {
      navigate("/configure-translations");
    } else {
      navigate(-1);
    }
  };

  const handleClick = () => {
    navigate(
      (headerData.page === "users" && "add-user") ||
        (headerData.page === "organisations" && "add-organisation") ||
        (headerData.page === "environments" && "add-environment") ||
        (headerData.page === "packages" && "add-package") ||
        (headerData.page === "vfusers" && "add-vfuser") ||
        (headerData.page === "reports" && "add-report")
    );
  };

  const handleExport = () => {
    dispatch(
      setButtonAction({
        page: "powerbi",
        action: "export",
      })
    );
  };

  const handleButtonClick = (action) => {
    dispatch(
      setButtonAction({
        page: pathName || "",
        action: action || "",
      })
    );
  };

  return (
    <>
      <div
        className={styles.topHeader}
        style={{
          height:
            headerData.page === "user-review" ||
            headerData.page === "setup-organisation"
              ? "120px"
              : headerData.page === "powerbi"
              ? "104px"
              : "160px",
        }}
      >
        <div className={styles.topheaderLeft}>
          {headerData.page === "dashboard" ? (
            <>
              <div className={styles.profileContainer}>
                {profileImage && (
                  <img
                    className={styles.clientUserAccountDetailsChild1}
                    alt=""
                    src={profileImage || ""}
                  />
                )}
                <div>
                  <span className={styles.helloTitle}>Hello</span>{" "}
                  <b className={styles.hiClientAdmin1}>{headerData?.title}</b>
                  <div className={styles.goremIpsumDolor1}>
                    {(headerData?.subTitle || "") + "  "}
                    {searchParams != "/admin" && (
                      <img
                        alt=""
                        className={styles.reporticongif}
                        src={require(`../../assets/images/dashboardheader.gif`)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : headerData.page === "user-review" ||
            headerData.page === "setup-organisation" ? (
            <>
              {/* <img alt="" src={VFLogo} /> */}
              <div className={styles.visualiseFundraising}>VISUALISE</div>
            </>
          ) : (
            <>
              {(headerData.page === "vfusers" ||
                headerData.page === "environments" ||
                headerData.page === "packages" ||
                headerData.page === "configure-translations" ||
                headerData.page === "channel-translation" ||
                headerData.page === "program-translation" ||
                headerData.page === "annualgiving-translation" ||
                headerData.page === "fundpurpose-translation" ||
                headerData.page === "philanthropic-translation" ||
                headerData.page === "appeal-category-translation" ||
                headerData.page === "appeal-categories" ||
                headerData.page === "appeal-custom-categories" ||
                headerData.page === "campaign-categories" ||
                headerData.page === "campaign-custom-categories" ||
                headerData.page === "appeal-id" ||
                headerData.page === "campaign-id" ||
                headerData.page === "dollar-threshold" ||
                headerData.page === "fund-categories" ||
                headerData.page === "fund-types" ||
                headerData.page === "fund-custom-fields" ||
                headerData.page === "custom-fields-categories" ||
                headerData.page === "expense-target") && (
                <div
                  className={styles.backButtonContainer}
                  onClick={handleGoBack}
                >
                  <img alt="LeftArrow" src={LeftArrow} />
                  <div className={styles.backButton}>Back</div>
                </div>
              )}
              {headerData?.title && (
                <b
                  className={
                    headerData.page === "powerbi"
                      ? styles.powerBiTitle
                      : styles.headerTitle
                  }
                >
                  {headerData?.mainTitle && headerData?.mainTitle}{" "}
                  {headerData?.mainTitle && <ArrowRightGray />}{" "}
                  {headerData?.title}
                </b>
              )}
              {headerData?.subTitle && (
                <div className={styles.goremIpsumDolor1}>
                  {headerData?.subTitle || ""}
                </div>
              )}
              {headerData.page === "powerbi" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div className={styles.lastUpdated}>
                    Data Last Updated{" "}
                    {envLastUpdated
                      ? moment.utc(envLastUpdated).local().format(dateFormate) +
                        " " +
                        moment.utc(envLastUpdated).local().format(timeFormate) +
                        " " +
                        tmzone
                      : "--"}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className={styles.topheaderRight}>
          {(headerData.page === "add-user" ||
            headerData.page === "add-organisation" ||
            headerData.page === "add-environment" ||
            headerData.page === "add-package" ||
            headerData.page === "add-vfuser" ||
            headerData.page === "my-account" ||
            headerData.page === "edit-vfuser" ||
            headerData.page === "edit-report" ||
            headerData.page === "edit-package" ||
            headerData.page === "edit-organisation" ||
            headerData.page === "edit-user" ||
            headerData.page === "edit-environment" ||
            headerData.page === "expense-target" ||
            headerData.page === "channel-translation" ||
            headerData.page === "program-translation" ||
            headerData.page === "annualgiving-translation" ||
            headerData.page === "fundpurpose-translation" ||
            headerData.page === "philanthropic-translation" ||
            headerData.page === "appeal-category-translation" ||
            headerData.page === "appeal-categories" ||
            headerData.page === "appeal-custom-categories" ||
            headerData.page === "campaign-categories" ||
            headerData.page === "campaign-custom-categories" ||
            headerData.page === "appeal-id" ||
            headerData.page === "campaign-id" ||
            headerData.page === "dollar-threshold" ||
            headerData.page === "fund-categories" ||
            headerData.page === "fund-types" ||
            headerData.page === "fund-custom-fields" ||
            headerData.page === "custom-fields-categories" ||
            headerData.page === "add-report") && (
            <div className={styles.fieldWrap}>
              <Box sx={{ display: "flex" }}>
                <Box sx={{ marginRight: "20px" }}>
                  <ButtonCta1
                    text="Cancel"
                    onClick={() => handleButtonClick("cancel")}
                    variant="contained"
                    disabled={false}
                    bgColor="#e0e0e0"
                    color="#000"
                    width="103px"
                    height="48px"
                  />
                </Box>
                {isTranslationAdded &&
                  (headerData.page === "appeal-categories" ||
                    headerData.page === "appeal-custom-categories" ||
                    headerData.page === "campaign-categories" ||
                    headerData.page === "campaign-custom-categories" ||
                    headerData.page === "appeal-id" ||
                    headerData.page === "campaign-id" ||
                    headerData.page === "dollar-threshold" ||
                    headerData.page === "fund-categories" ||
                    headerData.page === "fund-types" ||
                    headerData.page === "fund-custom-fields" ||
                    headerData.page === "custom-fields-categories") && (
                    <Box sx={{ marginRight: "20px" }}>
                      <ButtonCta1
                        text="Clear"
                        onClick={() => handleButtonClick("delete")}
                        variant="outlined"
                        disabled={false}
                        bgColor="#fff"
                        color="#f7954c"
                        width="103px"
                        height="48px"
                      />
                    </Box>
                  )}
                {(headerData.page === "appeal-categories" ||
                  headerData.page === "appeal-custom-categories" ||
                  headerData.page === "campaign-categories" ||
                  headerData.page === "campaign-custom-categories" ||
                  headerData.page === "appeal-id" ||
                  headerData.page === "campaign-id" ||
                  headerData.page === "dollar-threshold" ||
                  headerData.page === "fund-categories" ||
                  headerData.page === "fund-types" ||
                  headerData.page === "fund-custom-fields" ||
                  headerData.page === "custom-fields-categories") &&
                  transalationId === 2 && (
                    <Box sx={{ marginRight: "20px" }}>
                      <ButtonCta1
                        text="Add Custom Field"
                        onClick={() => handleButtonClick("addCustomField")}
                        variant="outlined"
                        disabled={false}
                        bgColor="#fff"
                        color="#f7954c"
                        height="48px"
                      />
                    </Box>
                  )}
                {/* {(headerData.page === "channel-translation" ||
                    headerData.page === "program-translation" ||
                    headerData.page === "annualgiving-translation" ||
                    headerData.page === "fundpurpose-translation" ||
                    headerData.page === "philanthropic-translation" ||
                    headerData.page === "appeal-category-translation") && (
                    <Box sx={{ marginRight: "20px" }}>
                      <ButtonCta1
                        text="Add Custom Field"
                        onClick={() => handleButtonClick("addCustomField")}
                        variant="contained"
                        disabled={false}
                        height="48px"
                      />
                    </Box>
                  )} */}
                {headerData.page !== "my-account" &&
                  headerData.page !== "edit-vfuser" &&
                  headerData.page !== "edit-package" &&
                  headerData.page !== "edit-organisation" &&
                  headerData.page !== "edit-user" &&
                  headerData.page !== "edit-environment" &&
                  headerData.page !== "edit-report" &&
                  headerData.page !== "channel-translation" &&
                  headerData.page !== "program-translation" &&
                  headerData.page !== "annualgiving-translation" &&
                  headerData.page !== "fundpurpose-translation" &&
                  headerData.page !== "philanthropic-translation" &&
                  headerData.page !== "appeal-category-translation" &&
                  !(
                    (headerData.page === "expense-target" ||
                      headerData.page === "appeal-categories" ||
                      headerData.page === "appeal-custom-categories" ||
                      headerData.page === "campaign-categories" ||
                      headerData.page === "campaign-custom-categories" ||
                      headerData.page === "appeal-id" ||
                      headerData.page === "campaign-id" ||
                      headerData.page === "dollar-threshold" ||
                      headerData.page === "fund-categories" ||
                      headerData.page === "fund-types" ||
                      headerData.page === "fund-custom-fields" ||
                      headerData.page === "custom-fields-categories") &&
                    isTranslationAdded
                  ) && (
                    <>
                      {!addButtonDisabled ? (
                        <CustomTooltip
                          title={"Please fill all the mandatory details."}
                          placement="bottom"
                        >
                          <Box>
                            <ButtonCta1
                              text={isTranslationPage ? "Save" : "Add"}
                              onClick={() => handleButtonClick("add")}
                              variant="contained"
                              disabled={!addButtonDisabled}
                              width="82px"
                              height="48px"
                            />
                          </Box>
                        </CustomTooltip>
                      ) : (
                        <Box>
                          <ButtonCta1
                            text={isTranslationPage ? "Save" : "Add"}
                            onClick={() => handleButtonClick("add")}
                            variant="contained"
                            disabled={!addButtonDisabled}
                            width="82px"
                            height="48px"
                          />
                        </Box>
                      )}
                    </>
                  )}
                {(headerData.page === "my-account" ||
                  headerData.page === "edit-vfuser" ||
                  headerData.page === "edit-package" ||
                  headerData.page === "edit-organisation" ||
                  headerData.page === "edit-user" ||
                  headerData.page === "edit-environment" ||
                  ((headerData.page === "expense-target" ||
                    headerData.page === "appeal-categories" ||
                    headerData.page === "appeal-custom-categories" ||
                    headerData.page === "campaign-categories" ||
                    headerData.page === "campaign-custom-categories" ||
                    headerData.page === "appeal-id" ||
                    headerData.page === "campaign-id" ||
                    headerData.page === "dollar-threshold" ||
                    headerData.page === "fund-categories" ||
                    headerData.page === "fund-types" ||
                    headerData.page === "fund-custom-fields" ||
                    headerData.page === "custom-fields-categories") &&
                    isTranslationAdded) ||
                  headerData.page === "edit-report") && (
                  <>
                    {!updateButtonDisabled ? (
                      <CustomTooltip
                        title={"Please update the details."}
                        placement="bottom"
                      >
                        <Box>
                          <ButtonCta1
                            text="Update"
                            onClick={() => handleButtonClick("update")}
                            variant="contained"
                            disabled={!updateButtonDisabled}
                            width="122px"
                            height="48px"
                          />
                        </Box>
                      </CustomTooltip>
                    ) : (
                      <Box>
                        <ButtonCta1
                          text="Update"
                          onClick={() => handleButtonClick("update")}
                          variant="contained"
                          disabled={!updateButtonDisabled}
                          width="122px"
                          height="48px"
                        />
                      </Box>
                    )}
                  </>
                )}
              </Box>
            </div>
          )}
          {(headerData.page === "users" ||
            headerData.page === "powerbi" ||
            headerData.page === "organisations" ||
            headerData.page === "environments" ||
            headerData.page === "packages" ||
            headerData.page === "vfusers" ||
            headerData.page === "reports") && (
            <div className={styles.fieldWrap}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box>
                  <ButtonCta1
                    text={
                      (headerData.page === "users" && "+ Add Users") ||
                      (headerData.page === "organisations" &&
                        "+ Add Organisation") ||
                      (headerData.page === "environments" &&
                        "+ Add Environment") ||
                      (headerData.page === "packages" && "+ Add Package") ||
                      (headerData.page === "vfusers" && "+ Add User") ||
                      (headerData.page === "powerbi" && "Export") ||
                      (headerData.page === "reports" && "+ Add Report")
                    }
                    onClick={
                      headerData.page === "powerbi" ? handleExport : handleClick
                    }
                    variant="contained"
                    disabled={exportLoading}
                    width="auto"
                    height="48px"
                    color={headerData.page === "powerbi" ? "#5a5a5a" : "#fff"}
                    bgColor={headerData.page === "powerbi" ? "#fff" : "#f7954c"}
                    startIcon={
                      exportLoading ? (
                        <CircularProgress size={15} color="inherit" />
                      ) : headerData.page === "powerbi" ? (
                        <DownloadIcon />
                      ) : null
                    }
                  />
                </Box>
              </Box>
            </div>
          )}
          {headerData.page === "dashboard" &&
            (userRole?.includes(CLIENT_ADMIN_ROLE_ID) ||
              userRole?.includes(VF_ADMIN_ROLE_ID)) &&
            searchParams === "/admin" && (
              <div className={styles.groupDiv}>
                <AddNewDropdown />
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default Header;
